package ru.villawonka.app.domain.usecase

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.UserSettingsDomain
import ru.villawonka.app.domain.repository.UserRepository

class GetUserSettingsUseCase(private val userRepository: UserRepository) {

    suspend operator fun invoke(): Either<NetworkFailure, UserSettingsDomain> =
        userRepository.getSettings()
}
